/**
 * Bank Entry Page - Main orchestrator for bank statement import workflow
 * Steps: Upload → Select Company/Bank → Preview & Edit → Confirm
 */

import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { AlertCircle } from 'lucide-react';
import { useBankEntryStore } from '../stores/bankEntryStore';
import {
  StepIndicator,
  UploadStep,
  SelectStep,
  ParsingStep,
  PreviewStep,
  ProcessingStep,
  CompleteStep,
} from './bank-entry';

const BankEntry: React.FC = () => {
  const { currentStep, error } = useBankEntryStore();
  console.log('[BankEntry] Main component - currentStep:', currentStep);

  const steps = ['Upload', 'Select', 'Preview', 'Complete'];
  const stepIndex = {
    upload: 0,
    select: 1,
    parsing: 1,  // Parsing is part of Select step visually
    preview: 2,
    processing: 2,
    complete: 3,
  }[currentStep];

  return (
    <DashboardLayout>
      <div className="container mx-auto py-6 px-4">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Bank Entry</h1>
          <p className="text-muted-foreground">
            Import bank statements and create vouchers in Tally
          </p>
        </div>

        <StepIndicator steps={steps} currentStep={stepIndex} />

        {error && (
          <div className="max-w-2xl mx-auto mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700">
            <AlertCircle className="w-5 h-5" />
            {error}
          </div>
        )}

        {currentStep === 'upload' && <UploadStep />}
        {currentStep === 'select' && <SelectStep />}
        {currentStep === 'parsing' && <ParsingStep />}
        {currentStep === 'preview' && <PreviewStep />}
        {currentStep === 'processing' && <ProcessingStep />}
        {currentStep === 'complete' && <CompleteStep />}
      </div>
    </DashboardLayout>
  );
};

export default BankEntry;
